import { ROLES } from "./roleHelpers";

// Mirrors trukkers_konnect_backend/constants/subscriptionPlans.js and the
// mobile app's SUBSCRIPTION_ROLES (TruckersKonnect/src/utils/constants.jsx).
// DRIVER stays free everywhere.
export const SUBSCRIPTION_ROLES = [
  ROLES.OWNER,
  ROLES.FLEET_MANAGER,
  ROLES.SERVICE_PROVIDER,
];

export const isPaidRole = (role) => SUBSCRIPTION_ROLES.includes(role);

// Same rule as isEntitled() in subscription.controller.js — kept in sync by
// hand since this is a small, stable check. "trialing" (web-only) counts.
const isEntitled = (sub) => {
  if (!sub) return false;
  if (sub.status === "active" || sub.status === "trialing") return true;
  if (sub.status === "cancelled") {
    return sub.expiresAt ? new Date(sub.expiresAt).getTime() > Date.now() : true;
  }
  return false;
};

/**
 * Combined mobile (RevenueCat) + web (Stripe) entitlement, computed
 * client-side from the user object the normal auth/profile calls already
 * return — no extra network round trip needed for the route gate.
 * Each source is checked independently; neither can hide the other's valid
 * subscription (see the comment on `subscription`/`webSubscription` in
 * user.model.js on the backend).
 */
export const getEffectiveEntitlement = (userData) => {
  const mobile = userData?.subscription;
  const web = userData?.webSubscription;

  if (isEntitled(mobile)) return { active: true, source: "mobile", subscription: mobile };
  if (isEntitled(web)) return { active: true, source: "web", subscription: web };
  return { active: false, source: null, subscription: null };
};

/** True when this role must be gated behind a subscription and isn't entitled. */
export const needsSubscription = (userData) => {
  if (!userData || !isPaidRole(userData.role)) return false;
  return !getEffectiveEntitlement(userData).active;
};
